<button type="button" class="help-text-trigger" (click)="toggle()" [attr.aria-expanded]="isOpen" aria-label="Pokaż informacje">
	<kendo-icon class="help-text-trigger__icon" [name]="'info'" [size]="'large'"></kendo-icon>
</button>

<div class="help-text-dialog-backdrop" *ngIf="isOpen" (click)="close()"></div>

<div class="help-text-dialog" *ngIf="isOpen" role="dialog" aria-modal="true" [attr.aria-label]="'global.helpText' | translate">
	<div class="help-text-dialog__header">
		<div class="help-text-dialog__title">
			<span>{{'global.helpText' | translate}}</span> 
			<button *ngIf="hasEditHelpTextAbility" kendoButton icon="edit" look="flat" (click)="edit()"> </button>
		</div>
		<button kendoButton icon="close" look="flat" (click)="close()"> </button>
	</div>

	<div class="help-text-dialog__body" *ngIf="!isLoading && !showErrorMessage; else helpTextState" [innerHTML]="descriptionHtml"></div>

	<ng-template #helpTextState>
		<app-loading-panel [isLoading]="isLoading"></app-loading-panel>
		<span class="error-label" *ngIf="showErrorMessage">{{ 'errors.cantGetHelpText' | translate }}</span>
	</ng-template>
</div>

<div kendoDialogContainer #helpTextDialog></div>